<template>
    <span>
        <span v-if="this.responsive" class="inline-block 2xl:hidden text-white text-xs py-1 text-center px-1 md:px-3 py-1" :class="color">{{ this.data.text.substring(0, 1) }}</span>
        <span v-if="this.responsive" class="hidden 2xl:inline-block text-white text-xs py-1 text-center px-3 py-1" :class="color">{{ this.data.text }}</span>
        <span v-if="!this.responsive" class="text-white text-xs py-1 text-center px-3 py-1" :class="color">{{ this.data.text }}</span>
    </span>
</template>

<script>
    export default {
        props: {
            data: Object,
            responsive: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            color() {
                switch (this.data.type) {
                    case 'red':
                        return {'bg-red-500': true};
                    case 'orange':
                        return {'bg-orange-500': true};
                    case 'blue':
                        return {'bg-blue-500': true};
                    case 'yellow':
                        return {'bg-yellow-500': true};
                    default:
                        return {'bg-green-600': true, 'border-green-700': true, 'animate-pulse': true};
                }
            }
        }
    }
</script>
